<div
    class="message-container popover-{{ verticalPosition }}"
    [ngClass]="caretHorizontalOffset"
    [style.text-align]="textAlign"
    [ngStyle]="cssOverrides"
    [innerHTML]="tooltipText"
></div>
